import { addClassesLinked, dontRepeatClass } from '@/models/utils'

export const state = () => ({
  isLoading: false,
  classes: [],
  newClasses: [],
  oldClasses: [],
  closedClasses: [],
  certification: true,
})

export const getters = {
  hasClasses(state) {
    return state.classes
  },
}

export const mutations = {
  toggleLoading(state) {
    state.isLoading = !state.isLoading
  },
  setClasses(state, classes) {
    state.classes = classes
    state.newClasses = state.classes.filter((classe) => !classe.is_legacy)
    state.oldClasses = state.classes.filter((classe) => classe.is_legacy)
  },
  setClosedClasses(state, classes) {
    state.closedClasses = classes
  },
  filterNewClasses(state, search) {
    const classes = state.classes.filter((classe) => !classe.is_legacy)
    state.newClasses = classes.filter((classe) => {
      return classe.name
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036F]/g, '')
        .includes(
          search
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036F]/g, '')
        )
    })
  },
}

export const actions = {
  async getClasses(store) {
    if (store.state.classes.length === 0) {
      store.commit('toggleLoading')
      const response = await this.$axios.get('/api/v1/academic/classes')
      const allClasses = addClassesLinked(response.data)
      store.commit('setClasses', allClasses.classesNoRepeat)
      store.commit('toggleLoading')
    }
  },
  async getClosedClasses(store) {
    if (store.state.closedClasses.length === 0) {
      store.commit('toggleLoading')
      const response = await this.$axios.get(
        '/api/v1/academic/classes?terminated=true'
      )

      const { classesNoRepeat: closedClasses, classesLinkeds } =
        addClassesLinked(response.data)

      if (store.state.classes.length > 0) {
        const ClassesLinkedsClosed = [...store.state.classes, ...classesLinkeds]
        const { classesNoRepeat } = dontRepeatClass(ClassesLinkedsClosed)
        store.commit('setClasses', classesNoRepeat)
      }

      store.commit('setClosedClasses', closedClasses)
      store.commit('toggleLoading')
    }
  },
}
